module.exports = __webpack_public_path__ + "img/frame04_stamp.eb94d971.png";